<template>
  <v-card>
    <v-toolbar flat dark dense color="secondary">
      <v-toolbar-title>오목</v-toolbar-title>
      <v-spacer/>
      <v-btn @click="clear" icon><v-icon>mdi-refresh</v-icon></v-btn>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="5">
          <v-card :loading="loading">
            <v-row v-for="(item, i) in cells" :key="i" no-gutters>
              <v-col cols="1" v-for="(subItem, j) in item" :key="(i * 12) + j">
                <v-responsive :aspect-ratio="1">
                  <v-card class="d-flex" height="100%" :color="(i+j)%2 ? 'grey lighten-3':'white'" tile outlined @click="save(subItem, i, j)">
                    <v-row no-gutters align="center" justify="center" height="100%">
                      <div v-if="subItem === 0"></div>
                      <v-icon v-else-if="subItem === 1">mdi-checkbox-blank-circle</v-icon>
                      <v-icon v-else-if="subItem === 2">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-row>
                  </v-card>
                </v-responsive>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="7">
          기록
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      cells: Array(12).fill(0).map(() => {
        return Array(12).fill(0)
      }),
      unsubscribe: null,
      loading: false
    }
  },
  created () {
    this.subscribe()
  },
  destroyed () {
    this.$firebase.database().ref().child('games').child('omok').off()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    clear () {
      this.cells = Array(12).fill(0).map(() => {
        return Array(12).fill(0)
      })
    },
    subscribe () {
      this.loading = true
      this.$firebase.database().ref().child('games').child('omok').on('value', (sn) => {
        this.loading = false
        const v = sn.val()
        if (!v) return
        this.cells = v.cells
      }, this.onError)
    },
    save (v, i, j) {
      v = (v + 1) % 3
      this.cells[i].splice(j, 1, v)

      this.$firebase.database().ref().child('games').child('omok').set({
        cells: this.cells
      })
    }

  }
}
</script>
